import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CertificadoInfo } from '../../core/services/web-pki.service';

export interface SelecionarCertificadoData {
  certificados: CertificadoInfo[];
}

@Component({
  standalone: true,
  selector: 'app-selecionar-certificado-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatRadioModule,
    MatProgressSpinnerModule,
  ],
  template: `
    <h2 mat-dialog-title>Selecione o certificado</h2>
    <mat-dialog-content class="conteudo">
      <p *ngIf="!data.certificados?.length" class="vazio">
        Nenhum certificado encontrado no dispositivo. Verifique se o token está conectado ou se o certificado A1 está instalado.
      </p>

      <mat-radio-group [(ngModel)]="thumbprintSelecionado" class="lista">
        <mat-radio-button
          *ngFor="let cert of data.certificados"
          [value]="cert.thumbprint"
          class="item">
          <div class="info">
            <div class="nome">{{ cert.subjectName }}</div>
            <div class="emissor">Emissor: {{ cert.issuerName }}</div>
            <div *ngIf="cert.validityEnd" class="validade">
              Válido até: {{ cert.validityEnd | date:'dd/MM/yyyy' }}
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancelar()">Cancelar</button>
      <button mat-raised-button color="primary" type="button"
        [disabled]="!thumbprintSelecionado"
        (click)="confirmar()">
        Confirmar
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .conteudo { min-width: 480px; }
      .vazio { color: #666; font-style: italic; padding: 1rem 0; }
      .lista { display: flex; flex-direction: column; gap: 0.5rem; }
      .item { padding: 0.5rem; border-radius: 4px; }
      .item:hover { background: #f5f5f5; }
      .info { display: flex; flex-direction: column; gap: 2px; }
      .nome { font-weight: 600; }
      .emissor, .validade { font-size: 0.85rem; color: #555; }
    `,
  ],
})
export class SelecionarCertificadoDialogComponent {
  public thumbprintSelecionado: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<SelecionarCertificadoDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: SelecionarCertificadoData
  ) {}

  confirmar(): void {
    if (!this.thumbprintSelecionado) return;
    this.dialogRef.close(this.thumbprintSelecionado);
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }
}
